import React, { useEffect, useState } from 'react';
import { Offcanvas, Button, Alert } from 'react-bootstrap';
import { FaTrash, FaPlus, FaMinus } from 'react-icons/fa';
import { HiOutlineShoppingCart } from 'react-icons/hi2';
import { useNavigate } from 'react-router-dom';
import { useCarrito } from '../../context/CarritoContext';
import { obtenerURLImagen } from '../../utils/imageUtils';
import './CarritoSidebar.css';

function CarritoSidebar({ show, handleClose }) {
  const {
    carritoItems,
    incrementarCantidad,
    decrementarCantidad,
    eliminarItem,
    vaciarCarrito,
    refrescarPrecios,
    total,
  } = useCarrito();
  const navigate = useNavigate();
  const [avisoPrecios, setAvisoPrecios] = useState(null);

  useEffect(() => {
    if (!show || carritoItems.length === 0) {
      return undefined;
    }

    let cancelled = false;

    const sincronizar = async () => {
      const resultado = await refrescarPrecios();
      if (cancelled) return;

      if (resultado.eliminados?.length) {
        setAvisoPrecios('Algunos productos ya no están disponibles y fueron quitados.');
      } else if (resultado.preciosActualizados) {
        setAvisoPrecios('Los precios se actualizaron según el catálogo vigente.');
      } else {
        setAvisoPrecios(null);
      }
    };

    sincronizar();

    return () => {
      cancelled = true;
    };
    // Solo al abrir el sidebar
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, refrescarPrecios]);

  const handleIrAlCarrito = () => {
    handleClose();
    navigate('/carrito');
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end" className="carrito-offcanvas">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <HiOutlineShoppingCart className="me-2" aria-hidden="true" />
          Carrito ({carritoItems.reduce((acc, item) => acc + item.cantidad, 0)})
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {carritoItems.length === 0 ? (
          <div className="carrito-vacio-sidebar">
            <p>Tu carrito está vacío</p>
          </div>
        ) : (
          <>
            {avisoPrecios && (
              <div className="px-3 pb-2">
                <Alert variant="warning" className="mb-2 py-2">
                  <small>{avisoPrecios}</small>
                </Alert>
              </div>
            )}

            <div className="carrito-items-list">
              {carritoItems.map((item) => (
                <div key={item.id} className="carrito-item-sidebar">
                  <img
                    src={obtenerURLImagen(item.imagenURL)}
                    alt={item.nombre}
                    className="item-imagen-sidebar"
                  />
                  <div className="item-info-sidebar">
                    <h6 className="item-nombre-sidebar">{item.nombre}</h6>
                    <p className="item-precio-sidebar">
                      ${Number(item.precio).toLocaleString()}
                    </p>

                    <div className="cantidad-controls-sidebar">
                      <button
                        className="btn-cantidad-sidebar"
                        onClick={() => decrementarCantidad(item.id)}
                        disabled={item.cantidad <= 1}
                      >
                        <FaMinus />
                      </button>
                      <span className="cantidad-valor-sidebar">{item.cantidad}</span>
                      <button
                        className="btn-cantidad-sidebar"
                        onClick={() => incrementarCantidad(item.id)}
                      >
                        <FaPlus />
                      </button>
                    </div>

                    <p className="item-subtotal-sidebar">
                      {(() => {
                        const unit = Number(item.precio);
                        const sub = (Number.isFinite(unit) ? unit : 0) * item.cantidad;
                        return `Subtotal: $${sub.toLocaleString()}`;
                      })()}
                    </p>
                  </div>
                  <button
                    className="btn-eliminar-sidebar"
                    onClick={() => eliminarItem(item.id)}
                    aria-label="Eliminar"
                  >
                    <FaTrash />
                  </button>
                </div>
              ))}
            </div>

            <div className="carrito-footer-sidebar">
              <div className="envio-mensaje-sidebar">
                <span>Envío a cargo del comprador</span>
              </div>
              <div className="total-sidebar">
                <span>Total:</span>
                <span className="total-valor-sidebar">${total.toLocaleString()}</span>
              </div>
              <Button
                variant="dark"
                className="btn-ir-carrito w-100 mb-2"
                onClick={handleIrAlCarrito}
              >
                Ir al carrito
              </Button>
              <button
                className="btn btn-outline-dark w-100 mb-2"
                onClick={vaciarCarrito}
              >
                Vaciar carrito
              </button>
              <button
                className="link-seguir-comprando"
                onClick={handleClose}
              >
                Seguir comprando
              </button>
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default CarritoSidebar;
